import { useLazyQuery } from '@apollo/client'
import { Modal, Paper, Slide, useMediaQuery, useTheme } from '@material-ui/core'
import { Pagination } from '@material-ui/lab'
import { useEffect } from 'react'

import { COMLOG_QUERY } from '../../graphql/comlog'
import { getDirection } from '../../localization'
import { ComlogData, ComLogFilters } from '../../types/monitoring'
import MonitoringFormListDesktop from './MonitoringFormList/MonitoringFormListDesktop'
import MonitoringFormListMobile from './MonitoringFormList/MonitoringFormListMobile'
import useStyles from './styles/index.styles'

interface ComlogModalProps {
  isOpen: boolean
  onClose: () => void
  filters: ComLogFilters
  page: number
  setpage: (v: number) => void
}
const ComlogModal: React.FC<ComlogModalProps> = ({
  isOpen,
  onClose,
  filters,
  page,
  setpage
}) => {
  const classes = useStyles()
  const theme = useTheme()

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const [getComlogs, { data, loading, refetch }] = useLazyQuery<{
    comLogs: ComlogData
  }>(COMLOG_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  })

  useEffect(() => {
    if (isOpen)
      getComlogs({
        variables: { input: filters }
      })
  }, [filters, isOpen])

  return (
    <Modal dir={getDirection()} open={isOpen} onClose={onClose}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.paper}>
          {isSmallScreen ? (
            <MonitoringFormListMobile listData={data?.comLogs.comLogs} />
          ) : (
            <MonitoringFormListDesktop
              listData={data?.comLogs.comLogs}
              refetch={refetch}
              loading={loading}
            />
          )}
          <div className={classes.paginationContainer}>
            <Pagination
              page={page}
              count={data?.comLogs.pageInfo.lastPage}
              color="primary"
              size={isSmallScreen ? 'small' : 'medium'}
              onChange={(_, value) => setpage(value)}
            />
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}

export default ComlogModal
